module.exports = __webpack_public_path__ + "img/logo.41606058.svg";